import { create } from 'zustand';
import { publicAPI } from '../services/api';

const useAppStore = create((set, get) => ({
  selectedEvent: null,
  showNomination: false,
  scrollToBoard: false,
  activeSection: 'home',

  // ── Event cache (shared across pages) ──
  events: [],
  eventsLoaded: false,
  eventsLoading: false,

  setSelectedEvent: (event) => set({ selectedEvent: event }),
  setShowNomination: (show) => set({ showNomination: show }),
  setScrollToBoard: (val) => set({ scrollToBoard: val }),
  setActiveSection: (id) => set({ activeSection: id }),

  /**
   * Fetch events once and cache in store.
   * Subsequent calls are no-ops unless force=true.
   */
  fetchEvents: async (force = false) => {
    const { eventsLoaded, eventsLoading } = get();
    if ((eventsLoaded && !force) || eventsLoading) return get().events;

    set({ eventsLoading: true });
    try {
      const res = await publicAPI.getEvents();
      const evts = res.data || [];
      set({ events: evts, eventsLoaded: true, eventsLoading: false });
      return evts;
    } catch (err) {
      console.error('[Store] Failed to load events:', err);
      set({ eventsLoading: false });
      return [];
    }
  },
}));

export default useAppStore;
